import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { signInApi } from '../data/authentication';
import { vetsApi } from '../data/vets';
import { claimApi } from '../data/claim';
import { documentApi } from '../data/document';
import { policyApi } from '../data/policy';
import { premiumsAndPaymentApi } from '../data/premiumsandpayments';
import { customerApi, customerAuth0Api } from '../data/customer';
import { liveVetApi } from '../data/liveVet';
import { petApi } from '../data/pet';
import { kontentApi } from '../data/kontentAi';
import authReducer from './slice/authSlice';
import { SLICES } from '../constants/slices';
import vetDetailsReducer from './slice/vetDetailsSlice';
import petDetailsReducer from './slice/petDetailsSlice';
import paymentReducer from './slice/paymentSlice';
import claimReducer from './slice/claimSlice';
import { renewalApi } from '../data/renewal';
import dashboardReducer from './slice/dashboardSlice';
import renewalReducer from './slice/renewalHubSlice';

const { VET_DETAILS, PET_DETAILS, PAYMENT, CLAIMS, AUTHENTICATION, KONTENT_AI, DASHBOARD, RENEWAL_HUB } = SLICES;

const store = configureStore({
  reducer: {
    [signInApi.reducerPath]: signInApi.reducer,
    [policyApi.reducerPath]: policyApi.reducer,
    [vetsApi.reducerPath]: vetsApi.reducer,
    [claimApi.reducerPath]: claimApi.reducer,
    [documentApi.reducerPath]: documentApi.reducer,
    [customerAuth0Api.reducerPath]: customerAuth0Api.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [premiumsAndPaymentApi.reducerPath]: premiumsAndPaymentApi.reducer,
    [liveVetApi.reducerPath]: liveVetApi.reducer,
    [petApi.reducerPath]: petApi.reducer,
    [kontentApi.reducerPath]: kontentApi.reducer,
    [renewalApi.reducerPath]: renewalApi.reducer,
    [AUTHENTICATION]: authReducer,
    [VET_DETAILS]: vetDetailsReducer,
    [PET_DETAILS]: petDetailsReducer,
    [PAYMENT]: paymentReducer,
    [CLAIMS]: claimReducer,
    [DASHBOARD]: dashboardReducer,
    [RENEWAL_HUB]: renewalReducer
  },
  // Adding the api middleware enables caching, invalidation, and polling of your endpoints
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
      .concat(signInApi.middleware)
      .concat(policyApi.middleware)
      .concat(vetsApi.middleware)
      .concat(claimApi.middleware)
      .concat(documentApi.middleware)
      .concat(premiumsAndPaymentApi.middleware)
      .concat(customerAuth0Api.middleware)
      .concat(customerApi.middleware)
      .concat(liveVetApi.middleware)
      .concat(petApi.middleware)
      .concat(kontentApi.middleware)
      .concat(renewalApi.middleware)
});

setupListeners(store.dispatch);

export default store;
